import { render, staticRenderFns } from "./baseActDisplayDashboardTable.vue?vue&type=template&id=39f2a7c3&scoped=true&"
import script from "./baseActDisplayDashboardTable.vue?vue&type=script&lang=js&"
export * from "./baseActDisplayDashboardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2a7c3",
  null
  
)

export default component.exports